import React, { useRef, useEffect, useState, lazy, Suspense } from 'react';
import PropTypes, { bool, number } from 'prop-types';
import PictionJS from 'piction-js';
import { injectIntl } from 'react-intl';
import Loader from '../ui/Loader';
import appConfig from '../../appConfig';
import { disableRightClick } from '../../utils/uiUtils';
import { connect } from 'react-redux';
import { viewTypes } from '../../constants/umoGallery';
// import OBJViewer from '../OBJViewer/index.js';
// import toWebVTT from 'srt-webvtt';
const mapStateToProps = (state) => ({
  umoCarousel: new Map(state.umoCarousel),
  mainUI: new Map(state.mainUI),
});
const OBJViewer = lazy(() => import('../OBJViewer/index'));
/* eslint-disable no-underscore-dangle */
function UMOMediaView({
  umo,
  umoCarousel,
  carouselIndex,
  isMediaObj,
  setIsMediaObj = () => {},
  mainUI,
  isZoomable = false,
  intl,
}) {
  const [media, setMedia] = useState(null);
  const fileExtension = umo.name.split('.').pop().toLowerCase();
  const webQualityType = umo.type || umo.webQuality.type;
  const webQualityURL =
    (umo.webQuality && umo.webQuality.url) ||
    (umo.playOnlyQuality && umo.playOnlyQuality.url) ||
    umo.thumbnail.url;
  const videoRef = useRef(null);
  const [isMediaLoading, setIsMediaLoading] = useState(false);
  const galleryViewType = mainUI.get('umoGalleryViewType');
  let audioRef = useRef(null);
  const iframeRef = useRef(null);
  const inFocusCarouselIndex =
    umoCarousel && umoCarousel.get
      ? umoCarousel.get('currentIndex')
      : undefined;

  //Effect to adjust the openseadragon zoomify iframe width and height
  useEffect(() => {
    if (isZoomable) {
      const handleIframeLoad = (iframe) => {
        setIsMediaLoading(false);
        try {
          const iframeDocument =
            iframe.contentDocument || iframe.contentWindow?.document;
          if (iframeDocument) {
            iframeDocument.body.style.margin = '0';
            const { width, height } = iframe.getBoundingClientRect();
            const openSeaDragonElements = iframeDocument.getElementsByClassName(
              'openseadragon-canvas'
            );

            Array.from(openSeaDragonElements).forEach((element) => {
              element.setAttribute(
                'style',
                `width: ${width - 2}px !important; height: ${
                  height - 2
                }px !important;`
              );
            });
          } else {
            console.warn(
              'Iframe document not accessible due to cross-origin restrictions.'
            );
          }
        } catch (error) {
          console.error(
            'Cannot access iframe content due to cross-origin restrictions:',
            error
          );
        }
      };
      const iframes = document.querySelectorAll('#compare-item');
      iframes.forEach((iframe) => {
        iframe.addEventListener('load', () => handleIframeLoad(iframe));
      });

      return () => {
        iframes.forEach((iframe) => {
          iframe.removeEventListener('load', () => handleIframeLoad(iframe));
        });
      };
    }
  }, [media, isZoomable]);

  function updateMedia() {
    if (
      appConfig.umoGallery?.filesWithNoPreview?.some(
        (file) => file.toLowerCase() === fileExtension
      )
    ) {
      setMedia(
        <div className="">
          <div className="photo-uploader__default-thumbnail">
            <span className="photo-uploader__default-thumbnail-text-loader">
              {fileExtension}
            </span>
          </div>
          <div className="font-sm-regular umo-media-view__info-text">
            {intl.formatMessage({ id: 'umoMediaView.previewUnavailable' })}
          </div>
        </div>
      );
    } else if (umo.thumbnail && umo.thumbnail._data.$.restricted === 'T') {
      setMedia(
        <img
          className={'umo-media-view__image'}
          alt={umo.name}
          src={'./images/thumb/restricted.jpg'}
          onContextMenu={disableRightClick}
        />
      );
    } else {
      switch (webQualityType) {
        case 'VIDEO':
          // let textTrackUrl;
          // if (umo.id == demoUMOID) {
          //   const response = await fetch('../../../assets/captions.srt');
          //   console.log(response);
          //   if (!response.ok) {
          //     throw new Error('Failed to fetch the file');
          //   }
          //   const srtContent = await response.text();
          //   textTrackUrl = await toWebVTT(
          //     new Blob([srtContent], { type: 'text/plain' })
          //   );
          // }
          setMedia(
            <video
              ref={videoRef}
              className="umo-media-view__video"
              playsInline
              controls
              controlsList="nodownload"
              onContextMenu={disableRightClick}
              loop
              poster=""
              autoPlay={galleryViewType != viewTypes.CAROUSEL}
            >
              <source src={webQualityURL} />
              {/* <track
                  kind="subtitles"
                  src={textTrackUrl}
                  srcLang="en"
                  label="English"
                  default={true}
                ></track>             */}
              <p>Video cannot be played in this browser</p>
            </video>
          );

          break;
        case 'AUDIO':
          setMedia(
              <div className="umo-media-view__audio-container">
                {galleryViewType === viewTypes.CAROUSEL ? (<img
                  className="umo-media-view__audio-thumbnail"
                  src='./images/thumb/audio.jpg'
                  alt={umo.name}
                  onContextMenu={disableRightClick}
                />) : null}
                <audio
                  ref={audioRef}
                  className="umo-media-view__audio"
                  src={webQualityURL}
                  autoPlay={galleryViewType != viewTypes.CAROUSEL}
                  controls
                  controlsList="nodownload"
                  onContextMenu={disableRightClick}
                  loop
                />
              </div>
          );
          break;
        case 'DOCUMENT':
        case 'HTML': {
          const original = umo.originalList.all[0]
            ? umo.originalList.all.filter((i) => i.index === '1')[0]
            : null;
          if (original) {
            const host = original._data.$.h.includes('/wds/')
              ? appConfig.cardURL
              : appConfig.hostURL;
            if (original.mimeType.includes('stl')) {
              if (!isMediaObj) setIsMediaObj(true);
              setMedia(
                <Suspense fallback={<Loader />}>
                  <OBJViewer
                    url={original.url}
                    width={500}
                    height={500}
                    fileName={original.fileName}
                    umoId={original.id}
                    isStlModel={true}
                  />
                </Suspense>
              );
            } else if (original.mimeType.includes('octet-stream')) {
              if (!isMediaObj) setIsMediaObj(true);
              setMedia(
                <Suspense fallback={<Loader />}>
                  <OBJViewer
                    url={original.url}
                    width={500}
                    height={500}
                    fileName={original.fileName}
                    umoId={original.id}
                    isStlModel={false}
                  />
                </Suspense>
              );
            } else {
              setMedia(
                <iframe
                  className="umo-media-view__html"
                  src={host + original._data.$.h}
                />
              );
            }
          } else {
            // in case no download rules exist for this type of media
            setMedia(
              <img
                className="umo-media-view__image"
                alt={umo.name}
                src={webQualityURL}
                loader={<Loader />}
                onContextMenu={disableRightClick}
              />
            );
          }
          break;
        }
        case 'RELATIONAL':
          setMedia(
            <img
              className={'umo-media-view__image'}
              alt={umo.name}
              src={'./images/thumb/relational.gif'}
              onContextMenu={disableRightClick}
            />
          );
          break;
        case 'PHOTO': {
          const original = umo.originalList.all[0]
            ? umo.originalList.all.filter((i) => i.index === '1')[0]
            : null;
          // display original for gifs
          const photoUrl =
            original && original.mimeType.includes('gif')
              ? original.url
              : webQualityURL;
          if (isZoomable && appConfig.useZoomify && umo.data.z[0]) {
            setIsMediaLoading(true);
            setMedia(
              <iframe
                className="umo-media-view__image-compare"
                src={appConfig.hostURL + umo.data.z[0]}
                id="compare-item"
                ref={iframeRef}
              />
            );
          } else
            setMedia(
              <img
                className="umo-media-view__image"
                alt={umo.name}
                src={photoUrl}
                onContextMenu={disableRightClick}
              />
            );
          break;
        }
        default:
          setMedia(
            <img
              className="umo-media-view__image"
              alt={umo.name}
              src={webQualityURL}
              onContextMenu={disableRightClick}
            />
          );
          break;
      }
    }
  }

  useEffect(() => {
    updateMedia();
  }, [umo]);

  // Pause audio or video if in carousel view and not the active index
  useEffect(() => {
    if (
      galleryViewType === viewTypes.CAROUSEL &&
      typeof carouselIndex === 'number' &&
      typeof inFocusCarouselIndex === 'number' &&
      carouselIndex !== inFocusCarouselIndex
    ) {
      if (videoRef.current && !videoRef.current.paused) {
        videoRef.current.pause();
      }
      if (audioRef.current && !audioRef.current.paused) {
        audioRef.current.pause();
      }
    }
  }, [galleryViewType, carouselIndex, inFocusCarouselIndex]);

  return (
    <div className="umo-media-view">
      {isMediaLoading && (
        <div className="umo-media-view-loader">
          <Loader isLarge={true} />
        </div>
      )}
      {media}
    </div>
  );
}

UMOMediaView.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO),
  umoCarousel: PropTypes.instanceOf(Map),
  carouselIndex: number,
  isMediaObj: bool,
  setIsMediaObj: PropTypes.func,
  mainUI: PropTypes.instanceOf(Map),
};

export default connect(mapStateToProps)(injectIntl(UMOMediaView));
